import { computed, ref } from "vue";
import { defineStore } from "pinia";

const ROLE_LABELS = [
  ["isRoot", "Root"],
  ["isOwner", "Власник"],
  ["isManager", "Адміністратор"],
  ["isStaff", "Персонал"],
];

export const useProfileStore = defineStore("profile", () => {
  const profile = ref(null);

  const fullName = computed(() =>
    [profile.value?.firstName, profile.value?.lastName]
      .map((part) => part?.trim())
      .filter(Boolean)
      .join(" "),
  );

  const initials = computed(() =>
    [profile.value?.firstName, profile.value?.lastName]
      .map((part) => part?.trim()?.[0])
      .filter(Boolean)
      .join("")
      .toUpperCase(),
  );

  const roleLabel = computed(() => {
    const rolesMap = profile.value?.rolesMap;

    const role = ROLE_LABELS.find(([key]) => rolesMap?.[key]);
    return role ? role[1] : "";
  });

  function setProfile(data) {
    profile.value = data;
  }

  function patchProfile(data) {
    profile.value = { ...(profile.value || {}), ...data };
  }

  return {
    profile,
    fullName,
    initials,
    roleLabel,
    setProfile,
    patchProfile,
  };
});
